export const getFontSizeByValue = (value) => `${Math.round(40 - `${value}`.length * 1.4)}`;
